export const api_getImgVerify = "api/Verify/getImgVerify"; //获取图片验证码

export const api_getNav = "api/adminUser/getNav"; //获取管理员可查看栏目
export const api_bindAisInfoFieldArr = "api/login/bindAisInfoFieldArr"; //获取部分字段可选信息
export const api_isAssociationAdmin =
  "api/adminAppletsAssociation/isAssociationAdmin"; //判断当前管理员是不是分会长
export const api_getAssociationAdminList =
  "api/adminAppletsAssociation/getAssociationAdminList"; //获取分会长管理员列表

export const api_apiVerify = "api/adminUser/apiVerify"; //接口权限验证
export const api_resetPasswdVerify = "api/adminUser/resetPasswdVerify"; //重置管理员密码接口权限验证
export const api_updateAdminUserVerify = "api/adminUser/updateAdminUserVerify"; //编辑管理员信息接口权限验证
export const api_adminUserList = "api/adminUser/adminUserList"; //管理员列表
export const api_createAdminUser = "api/adminUser/createAdminUser"; //新增管理员
export const api_resetPasswd = "api/adminUser/resetPasswd"; //重置管理员密码
export const api_updateAdminUser = "api/adminUser/updateAdminUser"; //编辑管理员信息
export const api_delAdminUser = "api/adminUser/delAdminUser"; //删除管理员信息
export const api_apiList = "api/adminUser/apiList"; //接口列表
export const api_powerTemplateList = "api/adminUser/powerTemplateList"; //角色模板列表
export const api_createPowerTemplate = "api/adminUser/createPowerTemplate"; //创建角色模板
export const api_updatePowerTemplate = "api/adminUser/updatePowerTemplate"; //更新角色模板
export const api_delPowerTemplate = "api/adminUser/delPowerTemplate"; //删除角色模板

export const api_getAisInfoById = "api/adminIndex/getAisInfoById"; //通过id获取用户信息
export const api_getAisInfo = "api/adminIndex/getAisInfoV2"; //获取全部校友数据

export const api_getApplyLog = "api/adminIndex/getApplyLog"; //获取校友申请邮箱记录（分页式）
export const api_updateEmailRemark = "api/adminUpdate/updateEmailRemark"; //更新校友邮箱登录提示
export const api_getEmailRemark = "api/exmail/getEmailRemark"; //获取邮箱得登录提示

export const api_exportAisLatestInfo = "api/adminExport/exportAisLatestInfo";
export const api_exportAisHonor = "api/adminExport/exportAisHonor";
export const api_exportAisJournal = "api/adminExport/exportAisJournal";
export const api_exportAisJournalSum = "api/adminExport/exportAisJournalSum";
export const api_exportAisEducation = "api/adminExport/exportAisEducation";
export const api_exportAisJobInfo = "api/adminExport/exportAisJobInfo";
export const api_downloadXlsx = "api/adminIndex/downloadXlsx";
export const api_exportSelectInfo = "api/adminExport/exportSelectInfo";

export const api_updateInfoById = "api/adminUpdate/updateInfoById";
export const api_updateAisById = "api/adminUpdate/updateAisById";
export const api_updateAisRemark = "api/adminUpdate/updateAisRemark";
export const api_updateAisLabel = "api/adminUpdate/updateAisLabel";
export const api_updateStudentByExcel = "api/adminUpdate/updateStudentByExcel";
export const api_updateStudentOne = "api/adminUpdate/updateStudentOne";
export const api_updateStudentsByYear = "api/adminUpdate/updateStudentsByYear";

export const api_bannerList = "api/adminApplets/bannerList"; //轮播图列表
export const api_bannerInfo = "api/adminApplets/bannerInfo"; //轮播图详情
export const api_delBanner = "api/adminApplets/delBanner"; //删除轮播图
export const api_updateBanner = "api/adminApplets/updateBanner"; //新增或编辑轮播图
export const api_getBannerLink = "api/adminApplets/getBannerLink"; //获取链接参数接口

export const api_getAssociationId = "api/adminApplets/getAssociationId"; //获取可选分会id（活动，资讯，风采分类列表）辅助接口
export const api_activityList = "api/adminApplets/activityList"; //校友活动列表
export const api_updateActivity = "api/adminApplets/updateActivity"; //新增或编辑活动
export const api_activityInfo = "api/adminApplets/activityInfo"; //获取活动详情
export const api_delActivity = "api/adminApplets/delActivity"; //删除活动详情

export const api_newsList = "api/adminApplets/newsList"; //资讯列表
export const api_delNews = "api/adminApplets/delNews"; //删除资讯
export const api_updateNews = "api/adminApplets/updateNews"; //新增或编辑资讯
export const api_newsInfo = "api/adminApplets/newsInfo"; //资讯详情

export const api_memorabiliaList = "api/adminApplets/memorabiliaList"; //校友风采列表
export const api_delMemorabilia = "api/adminApplets/delMemorabilia"; //删除校友风采
export const api_updateMemorabilia = "api/adminApplets/updateMemorabilia"; //编辑新增校友风采
export const api_memorabiliaInfo = "api/adminApplets/memorabiliaInfo"; //校友风采详情

export const api_associationList =
  "api/adminAppletsAssociation/associationList"; //校友分会列表
export const api_delAssociation = "api/adminAppletsAssociation/delAssociation"; //删除校友分会
export const api_updateAssociation =
  "api/adminAppletsAssociation/updateAssociation"; //编辑校友分会
export const api_associationInfo =
  "api/adminAppletsAssociation/associationInfo"; //校友分会详情
export const api_associationNewsList =
  "api/adminAppletsAssociation/associationNewsList"; //校友分会资讯列表
export const api_associationActivityList =
  "api/adminAppletsAssociation/associationActivityList"; //校友分会活动列表
export const api_associationImageList =
  "api/adminAppletsAssociation/associationImageList"; //校友分会照片列表
export const api_delAssociationImage =
  "api/adminAppletsAssociation/delAssociationImage"; //删除校友分会照片
export const api_addAssociationImage =
  "api/adminAppletsAssociation/addAssociationImage"; //新增校友分会照片
export const api_associationJoinList =
  "api/adminAppletsAssociation/associationJoinList"; //校友分会加入列表
export const api_adminAppletsAssociationFileList =
  "api/AdminAppletsAssociationFile/list"; //校友会文件系统列表
export const api_adminAppletsAssociationFileCreateFolder =
  "api/adminAppletsAssociationFile/createFolder"; //创建文件夹
export const api_adminAppletsAssociationFileUpload =
  "api/adminAppletsAssociationFile/upload"; //单文件上传
export const api_adminAppletsAssociationFileDelete =
  "api/adminAppletsAssociationFile/delete"; //批量删除
export const api_adminAppletsAssociationFileDownload =
  "api/adminAppletsAssociationFile/download"; //单文件下载
export const api_adminAppletsAssociationFileDownloadBatch =
  "api/adminAppletsAssociationFile/downloadBatch"; //批量下载
export const api_adminAppletsAssociationFileMove =
  "api/adminAppletsAssociationFile/move"; //批量移动
export const api_adminAppletsAssociationFileGetMovableFolderTree =
  "api/adminAppletsAssociationFile/getMovableFolderTree"; //获取可移动文件夹树
export const api_adminAppletsAssociationFileRenameFolder =
  "api/adminAppletsAssociationFile/renameFolder"; //文件夹重命名
export const api_adminAppletsAssociationFileRename =
  "api/adminAppletsAssociationFile/rename"; //文件重命名

export const api_adminAppletsAssociationTeamList =
  'api/adminAppletsAssociationTeam/list'; //校友会团队列表
export const api_adminAppletsAssociationTeamRoleList =
  'api/adminAppletsAssociationTeam/roleList'; //校友会团队角色列表
export const api_adminAppletsAssociationTeamCreate =
  'api/adminAppletsAssociationTeam/create'; //创建团队成员
export const api_adminAppletsAssociationTeamUpdate =
  'api/adminAppletsAssociationTeam/update'; //更新团队成员
export const api_adminAppletsAssociationTeamInfo =
  'api/adminAppletsAssociationTeam/info'; //获取团队成员详情
export const api_adminAppletsAssociationTeamDelete =
  'api/adminAppletsAssociationTeam/delete'; //删除团队成员
export const api_adminAppletsAssociationTeamExport =
  'api/adminAppletsAssociationTeam/export'; //导出团队成员列表

export const api_associationNewInfo =
  "api/adminAppletsAssociation/associationNewInfo"; //校友分会-校友资讯详情
export const api_associationUpdateNews =
  "api/adminAppletsAssociation/associationUpdateNews"; //校友分会-编辑或新增资讯
export const api_associationDelNews =
  "api/adminAppletsAssociation/associationDelNews"; //校友分会--删除校友资讯

export const api_associationActivityInfo =
  "api/adminAppletsAssociation/associationActivityInfo"; //校友分会--活动详情
export const api_associationUpdateActivity =
  "api/adminAppletsAssociation/associationUpdateActivity"; //校友分会--编辑或新增活动
export const api_associationDelActivity =
  "api/adminAppletsAssociation/associationDelActivity"; //校友分会--删除活动

export const api_dataAuthenticationList =
  "api/adminAisExamine/dataAuthenticationList"; //当然校友资料认证列表
  export const api_registeredMemberList =
  "api/adminAisExamine/registeredMemberList"; //注册校友资料认证列表
export const api_faceAuthenticationList =
  "api/adminAisExamine/faceAuthenticationList"; //人脸认证列表
export const api_authenticationInfo = "api/adminAisExamine/authenticationInfo"; //当然校友认证详情页
export const api_registeredMember = "api/adminAisExamine/registeredMember"; //注册校友认证详情页
export const api_examineAuthenticationLog =
  "api/adminAisExamine/examineAuthenticationLog"; //审核认证
export const api_searchStudentNo = "api/adminAisExamine/searchStudentNo"; //搜索可选校友
export const api_searchRegisteredMember = "api/adminAisExamine/searchRegisteredMember"; //搜索可选注册认证校友
export const api_execRegisteredMember = "api/adminAisExamine/execRegisteredMember"; //审核注册会员

export const api_activationList = "api/adminAisExamine/activationList"; //激活列表
export const api_exportActivationList =
  "api/adminAisExamine/exportActivationList"; //导出激活列表

export const api_activationInfo = "api/adminAisExamine/activationInfo"; //激活详情

export const api_shopList = "api/adminAppletsShop/shopList"; //校友企业列表
export const api_updateShop = "api/adminAppletsShop/updateShop"; //编辑或新增店铺
export const api_shopInfo = "api/adminAppletsShop/shopInfo"; //店铺详情
export const api_getRegion = "api/shop/getRegion"; //新建所在地
export const api_shopTypeInfo = "api/adminAppletsShop/shopTypeInfo"; //店铺类型详情
export const api_uploadShopImage = "api/adminAppletsShop/uploadShopImage"; //店铺详情图片上传辅助接口
export const api_delShop = "api/adminAppletsShop/delShop"; //删除店铺
export const api_shopTypeList = "api/adminAppletsShop/shopTypeList"; //店铺类型列表
export const api_updateShopType = "api/adminAppletsShop/updateShopType"; //新增或编辑分类
export const api_getParentList = "api/adminAppletsShop/getParentList"; //获取可选上级分类id列表
export const api_delShopType = "api/adminAppletsShop/delShopType"; //删除分类
export const api_shopTypeTreeList = "api/shop/shopTypeTreeList"; //获取店铺类型及其子类型
export const api_updateShopRecruit = "api/adminAppletsShop/updateShopRecruit"; //新增或编辑招聘信息
export const api_delShopRecruit = "api/adminAppletsShop/delShopRecruit"; //删除招聘信息
export const api_waitReviewShop = "api/adminAppletsShop/waitReviewShop"; //获取待审核企业列表
export const api_waitReviewShopInfo = "api/adminAppletsShop/waitReviewShopInfo"; //获取待审核企业详情
export const api_shopRecruit = "api/adminAppletsShop/shopRecruit"; //获取待审核招聘信息
export const api_execReviewShopInfo = "api/adminAppletsShop/execReviewShopInfo"; //审核校友企业

export const api_welfareList = "api/adminAppletsWelfare/welfareList"; //校友福利-列表
export const api_welfareInfo = "api/adminAppletsWelfare/welfareInfo"; //校友福利-详情
export const api_updateWelfare = "api/adminAppletsWelfare/updateWelfare"; //校友福利-编辑或新增
export const api_delWelfare = "api/adminAppletsWelfare/delWelfare"; //校友福利-删除
export const api_welfareRecruitList =
  "api/adminAppletsWelfare/welfareRecruitList"; //校友福利-企业招聘-列表
export const api_welfareRecruitInfo =
  "api/adminAppletsWelfare/welfareRecruitInfo"; //校友福利-企业招聘-详情
export const api_updateWelfareRecruit =
  "api/adminAppletsWelfare/updateWelfareRecruit"; //校友福利-企业招聘-编辑或新增
export const api_delWelfareRecruit =
  "api/adminAppletsWelfare/delWelfareRecruit"; //校友福利-企业招聘-删除
export const api_paramSurveyList = "api/adminAppletsWelfare/paramSurveyList"; //校友福利-参数-问卷列表
export const api_adminAppletsWelfareCampusVisitList =
  "api/adminAppletsWelfareCampusVisit/list"; //校友福利-返校报备-列表
export const api_adminAppletsWelfareCampusVisitDetail =
  "api/adminAppletsWelfareCampusVisit/detail"; //校友福利-返校报备-详情
export const api_adminAppletsWelfareCampusVisitBlacklist =
  "api/adminAppletsWelfareCampusVisit/blacklist"; //校友福利-返校报备-黑名单列表
export const api_adminAppletsWelfareCampusVisitAddBlacklist =
  "api/adminAppletsWelfareCampusVisit/addBlacklist"; //校友福利-返校报备-添加黑名单
export const api_adminAppletsWelfareCampusVisitDelBlacklist =
  "api/adminAppletsWelfareCampusVisit/delBlacklist"; //校友福利-返校报备-删除黑名单

export const api_donationList = "api/adminAppletsDonation/donationList"; //回馈母校-列表
export const api_donationInfo = "api/adminAppletsDonation/donationInfo"; //回馈母校-详情
export const api_updateDonation = "api/adminAppletsDonation/updateDonation"; //回馈母校-编辑或新增项目
export const api_delDonation = "api/adminAppletsDonation/delDonation"; //回馈母校-删除

export const api_getJournalById = "api/adminIndex/getJournalById"; //获取用户全部捐助信息（手动+小程序）
export const api_getDonationInfo = "api/adminIndex/getDonationInfo"; //捐助详情-手动录入
export const api_getAppletsDonationInfo =
  "api/adminIndex/getAppletsDonationInfo"; //捐助详情-小程序
export const api_updateDonationMail = "api/adminUpdate/updateDonationMail"; //捐助（票据或证书）邮寄发货
export const api_updateAisJournal = "api/adminUpdate/updateAisJournal"; //编辑捐助信息（手动录入信息）

export const api_updateIntegralMail =
  "api/adminAppletsIntegral/updateIntegralMail"; //订单发货
export const api_integralOrderInfo =
  "api/adminAppletsIntegral/integralOrderInfo"; //订单详情
export const api_integralOrderList =
  "api/adminAppletsIntegral/integralOrderList"; //订单管理列表
export const api_delIntegralProduct =
  "api/adminAppletsIntegral/delIntegralProduct"; //删除商品
export const api_uploadProductThumb =
  "api/adminAppletsIntegral/uploadProductThumb"; //商品宣传图上传功能
export const api_updateIntegralProduct =
  "api/adminAppletsIntegral/updateIntegralProduct"; //编辑或新增商品
export const api_integralProductInfo =
  "api/adminAppletsIntegral/integralProductInfo"; //商品详情
export const api_integralProductList =
  "api/adminAppletsIntegral/integralProductList"; //商品管理列表
export const api_integralAlumniList =
  "api/adminAppletsIntegral/integralAlumniList"; //积分管理

export const api_alumniNewPhotoList =
  "api/adminAppletsWelfare/alumniNewPhotoList"; //校友新头像列表
export const api_waitReviewPhotoList =
  "api/adminAppletsWelfare/waitReviewPhotoList"; //头像未审核列表
export const api_examineAlumniPhoto =
  "api/adminAppletsWelfare/examineAlumniPhoto"; //审核校友头像
export const api_updateAlumniPhotoStyle =
  "api/adminAppletsWelfare/updateAlumniPhotoStyle"; //修改上传头像要求样式
export const api_getAlumniPhotoStyle =
  "api/adminAppletsWelfare/getAlumniPhotoStyle"; //获取图片要求格式
export const api_downloadPhoto = "api/adminAppletsWelfare/downloadPhoto"; //下载图片

export const api_agreementManagement =
  "api/adminAppletsWelfare/agreementManagement"; //协议管理
export const api_updateAgreementManagement =
  "api/adminAppletsWelfare/updateAgreementManagement"; //更新协议管理

export const api_surveyList = "api/adminAppletsSurvey/surveyList"; //获取问卷列表
export const api_editSurvey = "api/adminAppletsSurvey/editSurvey"; //修改问卷状态
export const api_delsurvey = "api/adminAppletsSurvey/delsurvey"; //问卷答案列表删除
export const api_importSheet = "api/adminAppletsSurvey/importSheet"; //获取导入问卷
export const api_surveyInfo = "api/adminAppletsSurvey/surveyInfo"; //问卷详情
export const api_surveyAudit = "api/adminAppletsSurvey/answerAuditList"; //问卷审核
export const api_answerList = "api/adminAppletsSurvey/answerList"; //回收数据列表
export const api_answerInfo = "api/adminAppletsSurvey/answerInfo"; //问卷答案详情
export const api_allowAnswer = "api/adminAppletsSurvey/allowAnswer"; //问卷审核通过
export const api_notAllowAnswer = "api/adminAppletsSurvey/notAllowAnswer"; //问卷审核拒绝
export const api_exportAnswerList = "api/adminAppletsSurvey/exportAnswerList"; //导出问卷
export const api_delAnswer = "api/adminAppletsSurvey/delAnswer"; //问卷答案列表删除
export const api_statisticsIndex = "api/adminStatistics/index"; //数据分析表


export const api_functionList = "api/adminVisitLog/functionList"; //小程序功能列表
export const api_dataByFunction = "api/adminVisitLog/dataByFunction"; //某功能访问量
export const api_dataByFunctionExport = "api/adminVisitLog/export"; //导出数据

export const api_WishesList = "api/adminAppletsAnniversary/wishesList"; //回忆列表
export const api_WishesDetail = "api/adminAppletsAnniversary/wishesDetails"; //回忆详情
export const api_WishesEdit = "api/adminAppletsAnniversary/editWishes"; //新增、编辑回忆
export const api_WishesDel = "api/adminAppletsAnniversary/delWishes"; //删除回忆

export const api_adminAppletsAssociationPhotoAlbumList =
  'api/adminAppletsAssociationPhoto/albumList'; //校友会相册列表
export const api_adminAppletsAssociationPhotoCreateAlbum =
  'api/adminAppletsAssociationPhoto/createAlbum'; //校友会创建相册
export const api_adminAppletsAssociationPhotoEditAlbum =
  'api/adminAppletsAssociationPhoto/editAlbum'; //校友会编辑相册
export const api_adminAppletsAssociationPhotoDeleteAlbum =
  'api/adminAppletsAssociationPhoto/deleteAlbum'; //校友会删除相册
export const api_adminAppletsAssociationPhotoAlbumDetail =
  'api/adminAppletsAssociationPhoto/albumDetail'; //校友会相册详情（照片/视频列表）
export const api_adminAppletsAssociationPhotoDownloadPhoto =
  'api/adminAppletsAssociationPhoto/downloadPhoto'; //校友会相册单文件下载
export const api_adminAppletsAssociationPhotoUploadChunk =
  'api/adminAppletsAssociationPhoto/uploadPhotoChunk'; //校友会相册分片上传
export const api_adminAppletsAssociationPhotoMergeChunks =
  'api/adminAppletsAssociationPhoto/mergePhotoChunks'; //校友会相册分片合并
export const api_adminAppletsAssociationPhotoDeletePhoto =
  'api/adminAppletsAssociationPhoto/deletePhoto'; //校友会相册删除照片
export const api_adminAppletsAssociationPhotoEditPhoto =
  'api/adminAppletsAssociationPhoto/editPhoto'; //校友会相册编辑照片
export const api_adminAppletsAssociationPhotoSortPhoto =
  'api/adminAppletsAssociationPhoto/sortPhoto'; //校友会相册拖拽排序
export const api_adminAppletsAssociationPhotoDownloadAlbum =
  'api/adminAppletsAssociationPhoto/downloadAlbum'; //校友会相册打包下载

export const api_VideoList = "api/adminAppletsAnniversary/videoList"; //视频列表



// WEBPACK FOOTER //
// ./src/api/constant_api.js